import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import { convertSumWithLatestCurrencyRate, formatCurrency, formatShortDate } from "../../../../Utils/Utils";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import { numberEditor, priceEditor, textEditor } from "../../../../Utils/TableEditors";
import useApi from "../../../../Utils/BackendClient";
import { useFormik } from "formik";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";

import commonStyle from "../../CommonStyles.module.css";

const ReceptionActDetailsContent = ({ ctx, orderData, toast }) => {

    const { createReceptionActFromOrder } = useApi();

    const formik = useFormik({
        initialValues: {
            order_id: orderData.order_id,
            partner_id: orderData?.partner_id,
            act_number_autogenerate: true,
            products: orderData?.products ?? [],
            act_number: "",
            act_date: new Date(),
            pay_due_date: new Date(),
        },
        validate: values => {
            const errors = {};

            if (!values.partner_id) {
                errors.partner_id = "Виберіть партнера зі списку"
            }

            return errors;
        },
        onSubmit: async (values) => {

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                products: values.products.map(product => product.id),
            };

            const response = await createReceptionActFromOrder(payload);

            if(response.status === 201){
                toast.current.show({ severity: "success", summary: "Успіх", detail: `Партнерський акт № ${response.data.id} створено`, life: 3000 });
            }
            else{
                console.log(response.error);
                DisplayErrors(response.error, toast);
            } 
        }
    });

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const actToolbarLeftTemplate = () => {
        return <h3>Cтворення акту прийому товару</h3>;
    };

    const actToolbarRightTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Зберегти" severity="success" className={commonStyle.addButton} type="submit" />
            </div>
        );
    };

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <Toolbar className="mb-4" start={actToolbarLeftTemplate} end={actToolbarRightTemplate} />
            <div className="grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    <DropdownInput 
                        formik={formik}
                        paramName={"partner_id"}
                        context={ctx.enums.partners.data}
                        onChange={(val) => formik.setFieldValue("partner_id", val)}
                        label={"Партнер"} />
                    <CalendarInput formik={formik} paramName={"act_date"} label={"Дата акту"} />
                    <CalendarInput formik={formik} paramName={"pay_due_date"} label={"Очікувана дата оплати"} />
                    <ActNumberWithAutogenerateInput formik={formik} />
                </div>
                <div className="col-9">
                    {formik.values.products.length > 0 && <DataTable value={formik.values.products} header={setTableHeader("Товари")} editMode="cell">
                        <Column field="quantity" header="Кількість" editor={(options) => numberEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '5%' }} />
                        <Column field="description" header="Товар" editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '40%' }} />
                        <Column field="identifier" header="Ідентифікатор" editor={(options) => numberEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")}
                            body={(rowdata => rowdata.accounting_type === "INDIVIDUAL" ? rowdata.identifier : "-")} style={{ width: '25%' }}/>
                        <Column field="price" header="Ціна за одиницю" 
                            editor={(options) => priceEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")}
                            body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '15%' }} />
                        <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(convertSumWithLatestCurrencyRate(rowdata.currency, rowdata.price), "UAH")} style={{ width: '15%' }} />
                    </DataTable>}
                </div>
            </div>
        </form>)
}

export default ReceptionActDetailsContent;